import { debounce } from 'lodash-es';
import React, { useEffect } from 'react';

function useSticky(id, offsetTop = 0, offsetBottom = 0) {
  useEffect(() => {
    const handleScroll = () => {
      const sticky = window.document.getElementById(id);
      if (sticky) {
        const height = sticky.offsetHeight;
        const viewportHeight = window.innerHeight;
        const totalHeight = height + offsetTop + offsetBottom;

        if (sticky.style.position !== 'sticky') {
          sticky.style.position = 'sticky';
        }

        if (totalHeight < viewportHeight) {
          sticky.style.top = `${offsetTop}px`;
        } else {
          sticky.style.top = `${viewportHeight - height - offsetBottom}px`;
        }
      }
    };

    const handleResize = debounce(() => {
      handleScroll();
    });

    setTimeout(() => {
      window.addEventListener('scroll', handleScroll);
      window.addEventListener('resize', handleResize);
    }, 500);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, [id, offsetTop, offsetBottom]);
}

export default useSticky;
